import { Trans } from "@lingui/react/macro";

import { useApiErrorMessage } from "@/shared/api";
import { Button } from "@/shared/ui/button";

type MatchListErrorProps = {
  error: unknown;
  isRetrying: boolean;
  onRetry: () => void;
};

// Список не загрузился: текст ошибки и повтор.
export const MatchListError = ({ error, isRetrying, onRetry }: MatchListErrorProps) => {
  const message = useApiErrorMessage(error);
  return (
    <div
      role="alert"
      className="flex flex-col items-center gap-3 rounded-lg border border-bad/40 bg-bad/10 p-6 text-center"
    >
      <p className="font-semibold">
        <Trans>Could not load your matches</Trans>
      </p>
      {message !== null && <p className="text-sm text-muted">{message}</p>}
      <Button variant="outline" size="sm" loading={isRetrying} onClick={onRetry}>
        <Trans>Try again</Trans>
      </Button>
    </div>
  );
};
